import { useLocation, useNavigate } from "react-router-dom";
import { tField } from "@/lib/i18nField";
import { uiText } from "@/data/uiText";
import { locales } from "@/i18n/locales";
import { getEquivalentPath } from "@/data/selectors";

export default function LanguageSwitcher({ lang }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <label className="tgwe-language">
      <span>{tField(uiText.language, lang)}</span>
      <select
        value={lang}
        onChange={(event) => {
          navigate(getEquivalentPath(event.target.value, location.pathname));
        }}
      >
        {locales.map((locale) => (
          <option key={locale.code} value={locale.code}>
            {locale.label}
          </option>
        ))}
      </select>
    </label>
  );
}
